export default __webpack_public_path__ + "static/media/36I-102728_-15730_0.901eb8ed.jpg";